import { render, staticRenderFns } from "./bimTextMain.vue?vue&type=template&id=7355df6c&scoped=true&lang=html&"
import script from "./bimTextMain.vue?vue&type=script&lang=js&"
export * from "./bimTextMain.vue?vue&type=script&lang=js&"
import style0 from "./bimTextMain.vue?vue&type=style&index=0&id=7355df6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7355df6c",
  null
  
)

export default component.exports